import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "row-asin-list"
};
const _hoisted_2 = {
  class: "text"
};
const _hoisted_3 = ["src"];
import { ref, shallowRef, onMounted, computed } from 'vue';
import AsinItem from './AsinItem.vue';
import { getAsinBatch } from '@/models/api/detailPageApi';
import { useLess } from '@/models/hooks';
import constants, { encryptedMarketplaceId } from '@/constants';
import { jumpInteractionType } from '@/utils/common';
import { batchGetAsinsData } from '@/utils/landingPageCommon';
import { useRouter } from 'vue-router';
import { DISPLAY_MODE } from '@/configs/views/landingPage.js';
const API_MAX_ASINS_LENGTH = 20;
export default {
  __name: 'VerticalAsinShowCase',
  props: {
    asinClass: {
      type: String
    },
    asinIds: {
      type: Array
    },
    isWaterfallFlow: {
      type: Boolean
    },
    layoutType: {
      type: String
    },
    asinBadge: {
      type: String
    },
    isShowBuyButton: {
      type: Boolean
    },
    displayQuantity: {
      type: Number
    },
    moreIsShow: {
      type: Boolean
    },
    customTextContent: {
      type: String
    },
    interactionTypeInfo: {
      type: Array
    }
  },
  emits: ['onClickBuyPop'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    useLess('views/landingPage/asinShowcase/RowAsinList.less');
    const router = useRouter();
    const isLoading = ref(false);
    const isFinished = ref(false);
    const dataPagination = shallowRef(0);
    const count = shallowRef(10);
    const asinList = ref([]);
    const cptAsinItemStyle = computed(() => {
      return {
        ...(!props.isShowBuyButton && {
          height: 'auto'
        })
      };
    });
    const loadAsinList = async () => {
      isLoading.value = true;
      if (!props.asinIds || !props.asinIds.length) {
        isFinished.value = true;
        isLoading.value = false;
        return;
      }
      let asinIdList = [];
      if (props.layoutType === DISPLAY_MODE.NORMAL) {
        const length = props.displayQuantity > props.asinIds.length ? props.asinIds.length : props.displayQuantity;
        asinIdList = props.asinIds.slice(0, length);
        isFinished.value = true;
      } else {
        if (dataPagination.value * count.value >= props.asinIds.length) {
          isFinished.value = true;
          isLoading.value = false;
          return;
        }
        const asinIdListCopy = JSON.parse(JSON.stringify(props.asinIds));
        asinIdList.push(...asinIdListCopy.slice(dataPagination.value * count.value, (dataPagination.value + 1) * count.value));
        dataPagination.value += 1;
      }
      if (asinIdList.length > API_MAX_ASINS_LENGTH) {
        try {
          // Fragment request, previous request completed, next request
          batchGetAsinsData(asinIdList, API_MAX_ASINS_LENGTH, asinList);
        } catch (error) {
          console.error(error, 'api---getAsinBatch---error');
        } finally {
          isLoading.value = false;
        }
      } else {
        try {
          var _data;
          let {
            data
          } = await getAsinBatch({
            ids: asinIdList.join(','),
            marketplace: encryptedMarketplaceId,
            withCache: true
          });
          data = (_data = data) === null || _data === void 0 ? void 0 : _data.filter(i => {
            var _i$availability;
            return i.selectionEligible && ((_i$availability = i.availability) === null || _i$availability === void 0 ? void 0 : _i$availability.status) !== constants.AVAILABILITY_STATUS_ENUM.OUT_OF_STOCK;
          });
          asinList.value.push(...data);
        } catch (error) {
          console.error(error, 'api---getAsinBatch---error');
        } finally {
          isLoading.value = false;
        }
      }
    };
    const onClickBuyPop = item => {
      emit('onClickBuyPop', {
        merchantId: item.merchantId,
        selectedAsin: item.selectedAsin
      });
    };
    const handleSeeMore = () => {
      var _props$interactionTyp;
      jumpInteractionType(props === null || props === void 0 ? void 0 : (_props$interactionTyp = props.interactionTypeInfo) === null || _props$interactionTyp === void 0 ? void 0 : _props$interactionTyp[0], router);
    };
    onMounted(() => {
      loadAsinList();
    });
    return (_ctx, _cache) => {
      const _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_list, {
        loading: isLoading.value,
        "onUpdate:loading": _cache[0] || (_cache[0] = $event => isLoading.value = $event),
        finished: isFinished.value,
        "loading-text": _ctx.$t('modules.commonComponent.pullRefresh.LOADING'),
        onLoad: loadAsinList
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(asinList.value, asinItem => {
          return _openBlock(), _createBlock(AsinItem, {
            style: _normalizeStyle(cptAsinItemStyle.value),
            class: _normalizeClass([__props.asinClass, 'asin-item']),
            key: asinItem.id,
            asinItem: asinItem,
            asinBadge: __props.asinBadge,
            isShowBuyButton: __props.isShowBuyButton,
            onOnClickBuyPop: onClickBuyPop
          }, null, 8, ["style", "class", "asinItem", "asinBadge", "isShowBuyButton"]);
        }), 128))]),
        _: 1
      }, 8, ["loading", "finished", "loading-text"]), !__props.isWaterfallFlow && __props.moreIsShow ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "show-more",
        onClick: handleSeeMore
      }, [_createElementVNode("div", _hoisted_2, _toDisplayString(__props.customTextContent), 1), _createElementVNode("img", {
        src: `${_unref(constants).IMAGE_URL}assets/image/icons/rightArrowGrey.png`,
        alt: ""
      }, null, 8, _hoisted_3)])) : _createCommentVNode("", true)]);
    };
  }
};